import { CALLING_COUNTRY_CODES } from '@wix/form-validator';
import localeDataset from '@wix/locale-dataset-javascript';
import parsePhoneNumber, { AsYouType, isValidPhoneNumber } from 'libphonenumber-js';
import Metadata from 'libphonenumber-js/metadata.min.json';
export const PHONE_PREFIX = '+';
export function parseCountryCodeFromPhoneNumber(phoneNumber) {
  const parsedNumber = phoneNumber ? parsePhoneNumber(phoneNumber) : undefined;
  const parsedCountryCode = parsedNumber == null ? void 0 : parsedNumber.country;
  if (parsedCountryCode) {
    return parsedCountryCode;
  }
  const asYouType = new AsYouType();
  phoneNumber && asYouType.input(phoneNumber);
  const guessedCountryCode = asYouType.getCountry();
  return guessedCountryCode;
}
export function parseCountryCodeFromCallingCode(callingCode) {
  const countryByCallingCode = getCountryCodeByCallingCode(callingCode);
  return countryByCallingCode;
}
export function toLongCountryCode(shortCountryCode) {
  return shortCountryCode ? CALLING_COUNTRY_CODES[shortCountryCode] : undefined;
}
export function getCallingCode(countryCode) {
  var _localeDataset$getCou;
  return countryCode && ((_localeDataset$getCou = localeDataset.getCountryByKey(countryCode)) == null ? void 0 : _localeDataset$getCou.dialCode);
}
function getCountryCodeByCallingCode(phoneNumber) {
  var _Metadata$country_cal, _Metadata$country_cal2, _Metadata$country_cal3, _Metadata$country_cal4;
  phoneNumber = phoneNumber.trim();
  if (!phoneNumber.startsWith(PHONE_PREFIX)) {
    return undefined;
  }
  const withoutPrefix = phoneNumber.replace(/^\+/, '');
  const oneCharCode = withoutPrefix.substring(0, 1);
  const twoCharCode = withoutPrefix.substring(0, 2);
  const threeCharCode = withoutPrefix.substring(0, 3);
  const fourCharCode = withoutPrefix.substring(0, 4);
  const country = ((_Metadata$country_cal = Metadata.country_calling_codes[fourCharCode]) == null ? void 0 : _Metadata$country_cal[0]) || ((_Metadata$country_cal2 = Metadata.country_calling_codes[threeCharCode]) == null ? void 0 : _Metadata$country_cal2[0]) || ((_Metadata$country_cal3 = Metadata.country_calling_codes[twoCharCode]) == null ? void 0 : _Metadata$country_cal3[0]) || ((_Metadata$country_cal4 = Metadata.country_calling_codes[oneCharCode]) == null ? void 0 : _Metadata$country_cal4[0]);
  return country;
}
export function replaceCallingCode(phoneNumber, callingCode) {
  const countryCodeByPhoneNumber = parseCountryCodeFromPhoneNumber(phoneNumber);
  const countryCodeByCallingCode = parseCountryCodeFromCallingCode(phoneNumber);
  const countryCode = toLongCountryCode(countryCodeByPhoneNumber || countryCodeByCallingCode);
  const currentCallingCode = getCallingCode(countryCode);
  if (currentCallingCode) {
    return phoneNumber.replace(currentCallingCode, callingCode);
  } else {
    const withoutPrefix = phoneNumber.replace(PHONE_PREFIX, '');
    return `${callingCode}${withoutPrefix}`;
  }
}
export function parseLocalPhone(value, country) {
  if (value && country) {
    try {
      const phoneNumber = parsePhoneNumber(value, country);
      const formattedPhoneNumber = phoneNumber == null ? void 0 : phoneNumber.formatInternational();
      if (formattedPhoneNumber && isValidPhoneNumber(formattedPhoneNumber)) {
        return formattedPhoneNumber.replace(/\s+/g, '');
      }
    } catch (e) {}
  }
  return value;
}
//# sourceMappingURL=phone-input-utils.js.map